export default __webpack_public_path__ + "static/media/uv1.eb7b71e4.svg";